import { render } from "./BaseCheckBoxOther.vue?vue&type=template&id=f02ce936"
import script from "./BaseCheckBoxOther.vue?vue&type=script&lang=js"
export * from "./BaseCheckBoxOther.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__